import React, { useState } from "react";
import { Link } from "react-router-dom";
import Button from "../../components/ui/Button";
import Field from "../../components/ui/Field";
import Input from "../../components/ui/Input";
import { forgotPasswordRequest } from "../../services/api/auth.api";

const ForgotPasswordPage: React.FC = () => {
    const [email, setEmail] = useState("");
    const [globalError, setGlobalError] = useState<string | null>(null);
    const [successMessage, setSuccessMessage] = useState<string | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setGlobalError(null);
        setSuccessMessage(null);
        setIsSubmitting(true);

        try {
            await forgotPasswordRequest({ email });
            setSuccessMessage(
                "Если пользователь с таким e-mail существует, инструкция по восстановлению отправлена."
            );
        } catch (error) {
            const message =
                error instanceof Error ? error.message : "Не удалось отправить письмо";
            setGlobalError(message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="auth-layout">
            <div className="auth-panel">
                <div className="auth-panel-head">
                    <div className="auth-logo">S</div>
                    <p className="auth-kicker">ShowMust Admin</p>
                    <h1 className="auth-title">Восстановление пароля</h1>
                    <p className="auth-description">
                        Укажите e-mail администратора. Система использует endpoint восстановления
                        пароля для отправки письма со ссылкой.
                    </p>
                </div>

                <form className="auth-form" onSubmit={handleSubmit}>
                    <Field label="E-mail" htmlFor="email">
                        <Input
                            id="email"
                            type="email"
                            placeholder="admin@showmust.de"
                            autoComplete="email"
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                        />
                    </Field>

                    {globalError ? <div className="form-global-error">{globalError}</div> : null}
                    {successMessage ? <div className="form-global-success">{successMessage}</div> : null}

                    <Button type="submit" fullWidth disabled={isSubmitting}>
                        {isSubmitting ? "Отправляем..." : "Отправить ссылку"}
                    </Button>
                </form>

                <div className="auth-links">
                    <Link to="/login" className="text-link">
                        Вернуться ко входу
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
